"use client";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import axiosInstance from "@/service/axiosInstance";
import { toast } from "react-toastify";
import { useRouter, useSearchParams } from "next/navigation";
import Loader from "@/components/Loader/Loader";
import * as Yup from "yup";
import { ErrorMessage, Formik } from "formik";
import OTPInput from "react-otp-input";
import { getSortedSectionsWRTpage } from "@/utils/utils";
import { login, setUserRole } from "@/redux/features/authSlice";
import { useDispatch } from "react-redux";
import "react-phone-input-2/lib/style.css";
import { useSession, signIn, signOut } from "next-auth/react";
import { jwtDecode } from "jwt-decode";
import {
  APP_NAME,
  ToastOptions,
  HttpMethod,
  REDIRECT_ROUTES,
} from "@/utils/enum";
import vibgorone from "@/assets/images/logo/VIBGYORONE_LOGO.jpg";
import Olymmpia from "@/assets/images/logo/Olympialogo.png";
import logo_1 from "@/assets/images/logo/logo_01.jpg";
import Image from "next/image";
import { clearFilter } from "@/redux/features/filterSlice";

async function keycloakSessionLogOut() {
  try {
    await fetch(`/api/auth/logout`, { method: HttpMethod.GET });
  } catch (err) {
    console.error(err);
  }
}

const LoginArea = () => {
  const router = useRouter();
  const searchParams: any = useSearchParams();
  const redirect: any = searchParams.get("redirect");
  const redirectcamp: any = searchParams.get("redirectcamp");
  const redirectpsa: any = searchParams.get("redirectpsa");
  const redirectGI: any = searchParams.get("redirectGI");
  const redirectVAFP: any = searchParams.get("redirectVAFP");
  const v3redirect: any = searchParams.get("v3redirect");
  // Older Viva sends /login?redirect="true" (quoted); the redesigned event
  // detail page sends /login?redirect=true (unquoted). Accept both so the user
  // continues to the cart instead of falling through to Home.
  const wantsCart = redirect === "true" || redirect === '"true"';
  const postLoginTarget = wantsCart
    ? REDIRECT_ROUTES.CART
    : redirectpsa === "true"
      ? REDIRECT_ROUTES.PSA_REGISTER
      : redirectcamp === "true"
        ? REDIRECT_ROUTES.SUMMER_CAMP_REGISTER
        : redirectGI === "true"
          ? REDIRECT_ROUTES.TGIP_REGISTER
          : redirectVAFP === "true"
            ? REDIRECT_ROUTES.VAFP_REGISTER
            : v3redirect === "true"
              ? REDIRECT_ROUTES.V3_CART
              : REDIRECT_ROUTES.HOME;
  const [mobileNumber, setMobileNumber] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [loginPageData, setLoginPageData] = useState<any>([]);
  const [otpPageData, setOtpPageData] = useState<any>([]);
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [mobileNumberInputVisible, setMobileNumberInputVisible] =
    useState(false);
  const token = localStorage.getItem("token");
  if (token) {
    router.push(postLoginTarget);
  }
  const [resendEnabled, setResendEnabled] = useState(false);
  const [timer, setTimer] = useState(30);
  const initialValues = { otp: "", captcha: "" };
  const [countryCode, setCountryCode] = useState("");
  const validationSchema = Yup.object().shape({
    otp: Yup.string()
      .required("OTP is required")
      .length(4, "OTP must be exactly 4 digits"),
  });
  const fetchImages = async () => {
    try {
      const response = await axiosInstance.get("/homePage", {});
      const imageData = getSortedSectionsWRTpage(
        response.data.data,
        "Popular Event",
        "Login Page",
      );
      setLoginPageData(imageData);
    } catch (error) {}
  };
  let userRole: any = null;
  const messages: any = {
    201: "Something went wrong", // Default message for 201
    400: "Incorrect OTP!",
    429: "Something went wrong", // Default message for 429
  };

  const handleSubmitForm = async (values: any) => {
    try {
      console.log("inside handleSubmitForm ");
      setLoading(true);
      const response: any = await axiosInstance.post("/auth/verifyOtp", {
        phone_number: mobileNumber,
        otp: values?.otp,
      });

      console.log("🚀 ~ handleSubmitForm ~ response:", response);
      // const res:any=await axiosInstance.post("/auth/updateCaptcha",{
      //   phone_number: mobileNumber,
      //   captchaValue:values.captcha,
      //   otp: values?.otp,
      // })

      if (response?.status == 200) {
        if (response?.token) {
          localStorage.setItem("token", response?.token);
        }
        if (token) userRole = jwtDecode(response.token);
        dispatch(setUserRole(jwtDecode(response.token)?.role));
        dispatch(login());

        toast.success("You’ve successfully logged in!", ToastOptions);

        if (response?.userData.register == false) {
          if (wantsCart) {
            router.push(`/signup?redirect="true"`);
          } else {
            router.push(`/signup`);
          }
          return;
        } else {
          // Continue to the page the user was heading to (cart / module
          // register), otherwise Home. See postLoginTarget above.
          router.push(postLoginTarget);
          return;
        }
      }

      if (response?.response?.status == 400) {
        // toast.error("Incorrect OTP. Please try again.", {
        //   position: "top-right",
        //   autoClose: 5000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        // });
        toast.error("Incorrect OTP. Please try again.", ToastOptions);
      }

      // console.log("🚀 ~ handleSubmitForm ~ response?.response?.status:", response?.status)
      if (response?.status == 429) {
        // toast.error(
        //   response?.message ? response?.message : "Something went wrong",
        //   {
        //     position: "top-right",
        //     autoClose: 5000,
        //     hideProgressBar: false,
        //     closeOnClick: true,
        //     pauseOnHover: true,
        //     draggable: true,
        //     progress: undefined,
        //   }
        // );
        toast.error(
          response?.message ? response?.message : "Oops! Something went wrong.",
          ToastOptions,
        );
      }
      setLoading(false);
    } catch (error: any) {
      console.log(error);
      toast.error("Oops! Something went wrong.", ToastOptions);
      setLoading(false);
    }
  };
  const app_name = process.env.NEXT_PUBLIC_APP_NAME;

  const getLogo = () => {
    switch (app_name) {
      case APP_NAME.VIBGYOR_VIVA:
        return logo_1;
      case APP_NAME.VIBGYOR_ONE:
        return vibgorone;
      case APP_NAME.SUMMER_CAMP_PRIVATE:
        return Olymmpia;
    }
  };

  const handleResendOtp = async () => {
    try {
      setLoading(true);
      const resp: any = await axiosInstance.post("/auth/login", {
        phone_number: mobileNumber,
      });

      if (resp?.status === 200) {
        toast.success("OTP sent again!", ToastOptions);
        // Reset the timer and disable the resend button
        setResendEnabled(false);
        setTimer(30);
      }
      if (resp?.status == 400) {
        toast.error(resp.message, ToastOptions);
      }
      if (resp?.status == 429) {
        toast.error(resp?.message, ToastOptions);
      }
      setLoading(false);
    } catch (error: any) {
      console.log(error);
      toast.error("Oops! Something went wrong.", ToastOptions);
      setLoading(false);
    }
  };

  const handleMobileNumberChange = (e: any) => {
    console.log(
      "🚀 ~ handleMobileNumberChange ~  e.target.value:",
      e.target.value,
    );
    const onlyDigits = e.target.value.replace(/\D/g, "");
    if (onlyDigits.length <= 10) {
      setMobileNumber(onlyDigits);
      setIsButtonDisabled(onlyDigits.length !== 10); // Enable button only if the length is 10
    }
  };
  const handleSubmit = async () => {
    try {
      setLoading(true);
      const resp: any = await axiosInstance.post("/auth/login", {
        phone_number: mobileNumber,
      });

      if (resp?.status === 200) {
        toast.success(resp?.message, ToastOptions);

        setShowOTP(true);
        // router.push(`/otp?phone_number=${mobileNumber}`);
      }
      if (resp?.status == 400) {
        toast.error(resp.message, ToastOptions);
      }
      if (resp?.status == 429) {
        toast.error(resp?.message, ToastOptions);
      }
      if (resp?.status == 500) {
        toast.error("Oops! Something went wrong.", ToastOptions);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);

      console.log("error occured in login ", error);
      toast.error("Oops! Something went wrong.", ToastOptions);
    }
  };

  const getLoginText = () => {
    switch (process.env.NEXT_PUBLIC_APP_NAME) {
      case APP_NAME.VIBGYOR_ONE:
        return "Get ready to book exciting events at VIBGYOR ONE";
      case APP_NAME.SUMMER_CAMP_PRIVATE:
        return "Get ready to book exciting events at OYLMPIA SUMMER CAMP";
      default:
        return "Get ready to book exciting events at VIBGYOR VIVA";
    }
  };

  const { data: session, status }: any = useSession();
  console.log("🚀 ~ LoginArea ~ session:", session);

  useEffect(() => {
    dispatch(clearFilter()); //persistence filter - on login / logout reset them
    if (
      status != "loading" &&
      session &&
      session?.error === "RefreshAccessTokenError"
    ) {
      signOut({ callbackUrl: "/" });
    }
  }, [session, status]);

  useEffect(() => {
    fetchImages();
  }, [token]);
  // fetchImages();
  useEffect(() => {
    let interval: any;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setResendEnabled(true);
      clearInterval(interval);
    }
    return () => {
      clearInterval(interval);
      return;
    };
  }, [timer]);

  if (status == "loading") {
    console.log("🚀 ~ LoginArea ~ status:", status);
    return (
      <div
        className="d-flex justify-center"
        style={{ width: "222222px", height: "333333px" }}
      >
        <Loader />
      </div>
    );
  } else if (session) {
    router.push(postLoginTarget);
    return null;
  }

  return (
    <>
      {loading && <Loader />}
      {showOTP === false && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "#F5F5FF",
            minHeight: "90vh",
            padding: "1rem",
          }}
          onKeyDown={(e) => {
            const { key } = e;
            if (key === "Enter" && !isButtonDisabled) {
              handleSubmit();
            }
          }}
        >
          <div className="">
            <div className="row bg-white rounded-4 overflow-hidden shadow">
              <div className="col-12 col-md-6 p-4 d-flex align-items-center justify-content-center">
                <div className="w-100">
                  <h3>Login</h3>
                  <span className="sub-section-Text">{getLoginText()}</span>

                  {!mobileNumberInputVisible && (
                    <div className="d-flex flex-column gap-2 mt-4">
                      {app_name === APP_NAME.VIBGYOR_VIVA && (
                        <div
                          className="account-box d-flex p-2 border rounded-2 mb-2 cursor-pointer"
                          onClick={() =>
                            signIn("keycloak", { callbackUrl: postLoginTarget })
                          }
                        >
                          <div className="p-2">
                            <span className="fw-bold">With</span> VIBGYOR School
                            Account
                          </div>
                          <div className="d-flex align-items-center p-2">
                            <i className="bi bi-arrow-right-circle ms-2"></i>
                          </div>
                        </div>
                      )}

                      <div
                        className="account-box d-flex p-2 border rounded-2 cursor-pointer"
                        onClick={() => setMobileNumberInputVisible(true)}
                      >
                        <div className="p-2">
                          <span className="fw-bold">With</span> Mobile Number
                        </div>
                        <div className="d-flex align-items-center p-2">
                          <i className="bi bi-arrow-right-circle ms-2"></i>
                        </div>
                      </div>
                    </div>
                  )}

                  {mobileNumberInputVisible && (
                    <>
                      <input
                        type="tel"
                        pattern="[0-9]{10}"
                        onChange={(e) => {
                          handleMobileNumberChange(e);
                        }}
                        value={mobileNumber}
                        title="Please enter a 10-digit mobile number"
                        required
                        className="form-control mt-3"
                        style={{
                          borderRadius: "0.5rem",
                          height: "2.59rem",
                          border: "1px solid #A3A3A3",
                          paddingLeft: "10px",
                        }}
                      />
                      <span className="login-input-title">Mobile No.</span>
                      <button
                        disabled={isButtonDisabled}
                        onClick={handleSubmit}
                        className="btn w-100 mt-3"
                        style={{
                          backgroundColor: isButtonDisabled
                            ? "#A3A3A3"
                            : "#3F41D1",
                          color: "white",
                          fontSize: ".875rem",
                          padding: ".5rem",
                          borderRadius: "5rem",
                          cursor: isButtonDisabled ? "not-allowed" : "pointer",
                        }}
                      >
                        Send OTP
                      </button>
                    </>
                  )}
                </div>
              </div>

              <div
                className="col-12 col-md-6 text-white"
                style={{
                  backgroundColor: "#310000",
                  padding: "2rem",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                {process.env.NEXT_PUBLIC_APP_NAME ===
                APP_NAME.SUMMER_CAMP_PRIVATE ? (
                  <div className="d-flex align-items-center justify-content-center w-100">
                    <Link href="/" className="d-flex justify-content-center">
                      <Image
                        src={getLogo()}
                        alt="Homepage logo"
                        priority
                        style={{
                          width: "100%",
                          maxHeight: "200px",
                          objectFit: "contain",
                        }}
                      />
                    </Link>
                  </div>
                ) : loginPageData.length > 0 ? (
                  <>
                    <h5 className="text-center mb-4 text-white">
                      Popular Programs
                    </h5>
                    <div className="row justify-content-center">
                      {loginPageData.map((item: any) => (
                        <div
                          key={item.id}
                          className="col-6 col-sm-6 col-md-6 d-flex flex-column align-items-center mb-4"
                        >
                          {item.URL ? (
                            <Link href={item.URL} className="d-block">
                              <div
                                className="rounded-circle mb-2"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  backgroundImage: `url(${item.Image_Path})`,
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  margin: "0 auto",
                                }}
                              />
                            </Link>
                          ) : (
                            <div
                              className="rounded-circle mb-2"
                              style={{
                                width: "100px",
                                height: "100px",
                                backgroundImage: `url(${item.Image_Path})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                margin: "0 auto",
                              }}
                            />
                          )}
                          {item.URL ? (
                            <Link href={item.URL}>
                              <span className="text-white text-center">
                                {item.Title}
                              </span>
                            </Link>
                          ) : (
                            <span className="text-white text-center">
                              {item.Title}
                            </span>
                          )}
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <div className="d-flex align-items-center justify-content-center w-100">
                    <Link href="/" className="d-flex align-items-center">
                      <Image
                        src={getLogo()}
                        alt="Homepage logo"
                        priority
                        style={{
                          maxHeight: "200px",
                          width: "400px",
                          objectFit: "contain",
                        }}
                      />
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {showOTP && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "#F5F5FF",
            minHeight: "90vh",
            padding: "1rem",
          }}
        >
          <div className="container">
            <div className="row bg-white rounded-4 overflow-hidden shadow">
              <div className="col-12 col-md-6 p-4 d-flex align-items-center justify-content-center">
                <div style={{ width: "100%" }}>
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmitForm}
                  >
                    {({
                      values,
                      handleChange,
                      handleSubmit,
                      setFieldValue,
                      isValid,
                    }) => (
                      <form onSubmit={handleSubmit}>
                        <h3 className="mb-3">Verification OTP</h3>
                        <span className="sub-section-Text d-block mb-2">
                          Please enter the verification OTP sent to your
                          registered mobile number:{" "}
                          <strong>+91 {mobileNumber}</strong>
                        </span>

                        <div className="d-flex justify-content-center my-3">
                          <OTPInput
                            value={values.otp}
                            onChange={(otp) => setFieldValue("otp", otp)}
                            numInputs={4}
                            renderSeparator={
                              <span style={{ margin: "0 5px" }}></span>
                            }
                            renderInput={(props) => <input {...props} />}
                            inputStyle={{
                              width: "48px",
                              height: "48px",
                              fontSize: "20px",
                              margin: "0 5px",
                            }}
                            shouldAutoFocus
                          />
                        </div>

                        <ErrorMessage name="otp" component="div" />

                        <button
                          disabled={!isValid || loading}
                          onSubmit={() => {
                            handleSubmit;
                          }}
                          className="btn w-100 mt-3"
                          style={{
                            backgroundColor: isValid ? "#3F41D1" : "#A3A3A3",
                            color: "white",
                            borderRadius: "5rem",
                            fontSize: "0.9rem",
                            padding: ".5rem",
                            cursor: isValid ? "pointer" : "not-allowed",
                          }}
                        >
                          Submit
                        </button>

                        <div className="text-center mt-3">
                          <span
                            onClick={handleResendOtp}
                            style={{
                              color: resendEnabled ? "#3F41D1" : "#B0B0B0",
                              cursor: resendEnabled ? "pointer" : "not-allowed",
                              fontSize: "0.9rem",
                            }}
                          >
                            Resend OTP
                          </span>

                          {!resendEnabled && (
                            <div
                              style={{
                                color: "#3F41D1",
                                fontSize: ".875rem",
                                marginTop: "5px",
                              }}
                            >
                              You can resend the OTP in {timer} seconds
                            </div>
                          )}
                        </div>
                      </form>
                    )}
                  </Formik>
                </div>
              </div>

              <div
                className="col-12 col-md-6 text-white"
                style={{
                  backgroundColor: "#310000",
                  padding: "2rem",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                {loginPageData.length === 0 ? (
                  <div className="d-flex align-items-center justify-content-center w-100">
                    <Link href="/" className="d-flex justify-content-center">
                      <Image
                        src={getLogo()}
                        alt="Homepage logo"
                        priority
                        style={{
                          maxHeight: "200px",
                          width: "400px",
                          objectFit: "contain",
                        }}
                      />
                    </Link>
                  </div>
                ) : process.env.NEXT_PUBLIC_APP_NAME ===
                  APP_NAME.SUMMER_CAMP_PRIVATE ? (
                  <div className="d-flex align-items-center justify-content-center w-100">
                    <Link href="/" className="d-flex justify-content-center">
                      <Image
                        src={getLogo()}
                        alt="Homepage logo"
                        priority
                        style={{
                          width: "100%",
                          maxHeight: "200px",
                          objectFit: "contain",
                        }}
                      />
                    </Link>
                  </div>
                ) : (
                  <>
                    <h5 className="text-center mb-4 text-white">
                      Popular Programs
                    </h5>

                    <div className="row justify-content-center">
                      {loginPageData.length > 0 &&
                        loginPageData.map((item: any) => (
                          <div
                            key={item.id}
                            className="col-6 col-sm-6 col-md-6 d-flex flex-column align-items-center mb-4"
                          >
                            {item.URL ? (
                              <Link
                                href={item.URL}
                                className="d-block text-decoration-none"
                              >
                                <div
                                  className="rounded-circle mb-2"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    backgroundImage: `url(${item.Image_Path})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    margin: "0 auto",
                                  }}
                                />
                              </Link>
                            ) : (
                              <div
                                className="rounded-circle mb-2"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  backgroundImage: `url(${item.Image_Path})`,
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  margin: "0 auto",
                                }}
                              />
                            )}

                            {item.URL ? (
                              <Link
                                href={item.URL}
                                className="text-white text-center text-decoration-none"
                              >
                                {item.Title}
                              </Link>
                            ) : (
                              <span className="text-white text-center">
                                {item.Title}
                              </span>
                            )}
                          </div>
                        ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LoginArea;
